
const _ = require('lodash');
import ko from 'rgs-knockout';


console.warn('`Serializable` is deprecated, use something from `jsable` module instead');


function Serializable (props, opts) {
	/*
	 * Construct (de)serializable knockout model
	 *
	 * Arguments:
	 *   props -- object with properties you want to be serialized
	 *   opts  -- options, see below
	 *
	 * Return value:
	 *   Object with all the inherited properties and properties passed as
	 *   `props' argument and additional methods described below.
	 *
	 * Instance methods:
	 *   toJS   -- convert model to plain JS object
	 *   fromJS -- load data from plain JS object to the model
	 *   extend -- create new model based on the current one
	 *   fromOther -- load data from other serializable `self.fromJS(other.toJS())`
	 * */

	opts = _.defaults(opts || {}, {
		inherit: {}, // Inherit from given object
		mapNames: {}, // Map names before converting to/from js

		// Override toJS and fromJS methods. Use this when stock toJS/fromJS are not good enough.
		// Each function gets the super method as the first argument.
		toJS: function (sup) {
			return sup();
		},
		fromJS: function (sup, js) {
			return sup(js);
		},
	});

	let mapNamesToJS;
	if (opts.mapNames) {
		if ('function' == typeof opts.mapNames.toJS) {
			mapNamesToJS = opts.mapNames.toJS;
		} else {
			mapNamesToJS = function (x) {
				return x in opts.mapNames ? opts.mapNames[x] : x;
			};
		}
	} else {
		mapNamesToJS = function (x) {
			return x;
		};
	}

	let mapNamesFromJS;
	if (opts.mapNames) {
		if ('function' == typeof opts.mapNames.fromJS) {
			mapNamesFromJS = opts.mapNames.fromJS;
		} else {
			mapNamesFromJS = function (x) {
				for (const k in opts.mapNames) {
					const v = opts.mapNames[k];
					if (v === x) {
						return k;
					}
				}
				return x;
			};
		}
	} else {
		mapNamesFromJS = function (x) {
			return x;
		};
	}

	const sup = opts.inherit; // super
	const serializable = _.extend(Object.create(sup), props);
	const self = Object.create(serializable);
	self.serializable = serializable;

	var toJS = function (obj) {
		if (obj != null && 'function' == typeof obj.toJS) {
			return obj.toJS();
		}
		if (_.isArray(obj)) {
			return _.map(obj, function (val) {
				return toJS(val);
			});
		}
		if (ko.isObservable(obj)) {
			return toJS(obj());
		}
		return obj;
	};

	const self_toJS = function () {
		let js = {};
		if ('function' == typeof sup.toJS) { // Call super toJS if it's there
			js = sup.toJS(...arguments);
		}
		_.each(serializable, function (v, k) {
			if (!{}.hasOwnProperty.call(serializable, k)) {
				return;
			} // Only work on our own properties (skip ones handled by super)
			js[mapNamesToJS(k)] = toJS(v);
		});
		return js;
	};

	self.toJS = function () {
		return opts.toJS.call(self, self_toJS);
	};

	var fromJS = function (target, targetKey, js) {
		const targetVal = target[targetKey];
		if (targetVal != null && 'function' == typeof targetVal.fromJS) {
			targetVal.fromJS(js);
			return;
		}
		if (ko.isObservable(targetVal)) {
			const currentVal = targetVal();
			if (currentVal != null && 'function' == typeof currentVal.fromJS) {
				currentVal.fromJS(js);
				return;
			}
			if (ko.isObservable(currentVal)) {
				fromJS({x: currentVal}, 'x', js);
				return;
			}
			if (ko.isWriteableObservable(targetVal)) {
				targetVal(js);
				return;
			}
			return;
		}
		target[targetKey] = js;
	};

	const self_fromJS = function (js) {
		if ('function' == typeof sup.fromJS) { // Call super fromJS if it's there
			sup.fromJS(...arguments);
		}
		if (_.isArray(js) || (js && 'object' === typeof js)) {
			_.each(js, function (v, k) {
				const targetKey = mapNamesFromJS(k);
				if (!{}.hasOwnProperty.call(serializable, targetKey)) {
					return;
				} // Only work on our own properties (skip ones handled by super)
				fromJS(serializable, targetKey, v);
			});
		}
	};

	self.fromJS = function (js) {
		return opts.fromJS.call(self, self_fromJS, js);
	};

	self.fromOther = function (other) {
		return self.fromJS(other.toJS());
	};

	self.extend = function (props, opts) {
		opts = _.extend({}, opts, {
			inherit: self,
		});

		return Serializable(props, opts);
	};

	return self;
}

module.exports = Serializable;


